import React from 'react';
import clsx from 'clsx';
import { CancelButton, ConfirmButton, ServiceDialog } from '../../styling/Styles'

const PopUp = (props) => {

    const {
        openAlert,
        setOpenAlert,
        handleCancel,
        handleConfirm,
        title,
        insideDescription,
        confirmText,
        cancelText,
        cause
    } = props;

    const closePopUp = () => {
        setOpenAlert(false)
    }

    return (
            <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            > 
                 <div className={clsx('titlePopUp','paddingTitle')}> 
                    {title}
                    <div
                        onClick={closePopUp}
                        className={clsx('gjs-mdl-btn-close')}
                        style={{ fontSize: '2.2rem' }}
                        data-close-modal=""
                        aria-hidden="true"
                    >
                        ⨯
                    </div>
                </div>
                 <div className ='paddingTitle'>
                        <div className={clsx('spacingTopDiv')} style={{display: 'flex', justifyContent: 'center'}}>
                            {insideDescription}
                        </div>
                    
                    <div  
                        style={{
                            justifyContent:'space-between',
                            display: 'flex',
                            flexDirection: 'row', 
                            marginTop: '2vw',
                        }}

                    >
                        <div >
                            { cancelText !== undefined  && 
                                <CancelButton onClick={handleCancel}>
                                    {cancelText}
                                </CancelButton>
                            }
                        </div>
                        <div className={clsx('flexRowDirection')}>
                            <ConfirmButton id={`confirmButtonPopUp${cause}`} onClick={handleConfirm}>
                                {confirmText}
                            </ConfirmButton>
                        </div>
                    </div>
                </div>

            </ServiceDialog>
		)
}

export default PopUp;
